import React from 'react'
import { Form, Modal } from 'react-bootstrap'
import ApplyLeaveLottie from './animation/ApplyLeaveLottie.js'



const ApplyLeaveLottieModal = (props) => {
    return (
        <section className='modal-common-class-hrms'>
            <Modal
                {...props}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="add-modal"
            >
                <Modal.Body>
                    <div className='below-bodyy'>
                        <div className='donwload-div d-flex justify-content-center'>
                            <ApplyLeaveLottie/>
                            <h6 className='mt-2'> Leave applied Successfully!</h6>
                        </div>
                    </div>

                </Modal.Body>
            </Modal>
        </section>
    )
}

export default ApplyLeaveLottieModal